/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetApiPayments200, GetApiPayments400, GetApiPayments403, GetApiPayments404, GetApiPayments500, GetApiPaymentsQueryParams, GetApiPaymentsQueryResponse } from "../entities/GetApiPayments";
import { modelsErrorResponseSchema } from "./models/errorResponseSchema";
import { modelsPaymentStatusOutputSchema } from "./models/paymentStatusOutputSchema";
import { z } from "zod/v4";

export const getApiPaymentsQueryParamsSchema = z.object({
    "branch_id": z.coerce.number().int().min(1).describe("ID филиала"),
"visit_group_id": z.string().describe("ID группы записей")
    }) as unknown as z.ZodType<GetApiPaymentsQueryParams>

/**
 * @description OK
 */
export const getApiPayments200Schema = z.lazy(() => modelsPaymentStatusOutputSchema) as unknown as z.ZodType<GetApiPayments200>

/**
 * @description Bad Request
 */
export const getApiPayments400Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiPayments400>

/**
 * @description Forbidden
 */
export const getApiPayments403Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiPayments403>

/**
 * @description Not Found
 */
export const getApiPayments404Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiPayments404>

/**
 * @description Internal Server Error
 */
export const getApiPayments500Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiPayments500>

export const getApiPaymentsQueryResponseSchema = z.lazy(() => getApiPayments200Schema) as unknown as z.ZodType<GetApiPaymentsQueryResponse>